import { db } from '../../config/Fire';
import * as Constants from '../../constants';

export const SET_COMPANIES = 'SET_COMPANIES';

const setCompanies = payload => ({ type: SET_COMPANIES, payload });

export const getAllCompanies = payload => {
    return dispatch => {
        return db.ref(`${Constants.MAIN_NODES.COMPANIES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists()) {
                    var companies = snapshot.val();
                    dispatch(setCompanies(companies));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setCompanies(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setCompanies(null));
            });
    };
};